import type { GetUploadMetaProps, Metadata } from './types'

function getUploadMeta(props: GetUploadMetaProps) {
  const { claimDetails, claimForm, identity, claimHandlers, handler, sourceSystem } = props
  const meta: Metadata = {
    batchId: '',
    trackingId: '',
    claim: {
      claimNumber: claimDetails.claim,
      claimantNumber: claimDetails.lob === 'W' ? '001' : '000',
      systemSource: claimDetails.systemSource ?? '',
      claimAfo: claimDetails.afo ?? '',
      claimAfoType: claimDetails.afoType ?? '',
      digitalFileUpload: {
        lossDate: claimDetails.dateOfLoss,
        senderName: identity.name,
        senderEmail: identity.email,
        role: claimForm.roleInClaim ?? ''
      },
      contactUid: '',
      handlerAfo: ''
    },
    userToken: claimDetails.userToken ?? '',
    sourceSystem: sourceSystem,
  }

  if (handler && handler !== 'other') {
    const selectedHandler = claimHandlers.find(c => c.contactUId.toString() === handler)
    if (selectedHandler) {
      meta.claim.contactUid = selectedHandler.contactUId
      meta.claim.handlerAfo = selectedHandler.officeCode
    }
  }

  return meta
}

export { getUploadMeta }
